import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from 'components/Loader';

const BoxWithTwoSections = ({ textObject, data, isLoading }) => {
  return (
    <div className="flex flex-col lg:flex-row card p-0 mt-5 mb-8">
      <div
        className={`lg:border-r lg:border-b-0 border-b border-gray-200 flex-1 grid p-6 lg:p-12 lg:place-self-start gap-y-2 ${
          isLoading ? 'relative h-48' : ''
        }`}
      >
        {isLoading ? (
          <Loader fullScreen={false} className="-mt-16 justify-center" />
        ) : (
          Object.entries(data.left).map(([key, value]) => (
            <div key={key} className="grid grid-cols-2">
              <span className="text-javelin-gray-light text-xs">
                {textObject[key]}
              </span>
              <span className="text-javelin-gray-dark text-xs overflow-hidden overflow-ellipsis">
                {value ?? '-'}
              </span>
            </div>
          ))
        )}
      </div>
      <div
        className={`flex-1 grid p-6 lg:p-12 lg:place-self-start gap-y-2 ${
          isLoading ? 'relative h-48' : ''
        }`}
      >
        {isLoading ? (
          <Loader fullScreen={false} className="-mt-16 justify-center" />
        ) : (
          Object.entries(data.right).map(([key, value]) => (
            <div key={key} className="grid grid-cols-2" data-testid={key}>
              <span className="text-javelin-gray-light text-xs">
                {textObject[key]}
              </span>
              <span className="text-javelin-gray-dark text-xs overflow-hidden overflow-ellipsis">
                {value === true ? (
                  <FontAwesomeIcon
                    icon="check-circle"
                    className="text-brand-primary w-4 h-4 my-auto"
                  />
                ) : (
                  value ?? '-'
                )}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

BoxWithTwoSections.propTypes = {
  data: PropTypes.shape({
    left: PropTypes.object,
    right: PropTypes.object,
  }).isRequired,
  textObject: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};
BoxWithTwoSections.defaultProps = {
  isLoading: false,
};

export default memo(BoxWithTwoSections);
